<template>
  <div>
    <div id="system-env" style="height: 400px; width: 488px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      total: 0,
      android: 0,
      iPhone: 0,
      pc: 0,
      label: {
        show: true,
        formatter: [
          "{a|{a} }", //引导线上面文字
          "{b|}", //引导线下面文字
        ].join("\n"), //用\n来换行
        // fontSize: "14",
        // fontWeight: "300",
        color: "#434343",
        position: "outside",
        //a和b来识别不同的文字区域
        rich: {
          a: {
            left: 30,
            padding: [0, 10, -20, 10],
            fontWeight: "300",
            fontSize: "14",
          },
          b: {
            height: 5,
            width: 5,
            lineHeight: 5,
            marginBottom: 10,
            padding: [0, -5],
            borderRadius: 5,
            borderWidth: 1,
            borderColor: "#4E97D6",
          },
        },
      },
      labelLine: {
        showAbove: true,
        show: true,
        smooth: 0.1,
        length: 35,
        length2: 45,
        color: "#4E97D6",
        lineStyle: {
          color: "#4E97D6",
          zIndex: 20000,
        },
      },
    };
  },
  watch: {
    userData: function (newVal, oldVal) {
      console.log(this.userData);
      for (let key in this.userData.os_result) {
        this.total += this.userData.os_result[key];
        if (key.indexOf("Android") != -1) {
          this.android += this.userData.os_result[key];
        } else if (key.indexOf("iOS") != -1) {
          this.iPhone += this.userData.os_result[key];
        } else{
           this.pc += this.userData.os_result[key];
        }
      }
      this.createChart();
    },
  },
  props: ["userData"],
  methods: {
    createChart() {
      let that = this;
      var chartDom = document.getElementById("system-env");
      var myChart = this.$echarts.init(chartDom);
      var option;

      option = {
        backgroundColor: "#fff",
        tooltip: {
          backgroundColor: "rgba(50,50,50,0.9)",
          trigger: "item",
          //   formatter: "{b}用户: {c} ({d}%)",
          formatter: "{a}: {b} {c}\n ({d}%)",
          borderColor: "transparent",
          borderWidth: "5",
          textStyle: {
            fontSize: "12",
            lineHeight: "12",
            height: "10",
            color: "white",
          },
        },

        series: [
          {
            name: "pc端用户",
            type: "pie",
            //起始刻度的角度，默认为 90 度，即圆心的正上方。0 度为圆心的正右方。
            // startAngle: 0,
            // hoverAnimation: false,
            emphasis: {
              scale: false,
            },
            radius: ["30%", "40%"],
            center: ["50%", "50%"],
            // label: {

            //     show: false,
            //     position: "center",
            //     color: "#fff",
            //     formatter: function (params) {
            //       return params.value;
            //     },

            // },
            labelLine: {
              show: false,
            },
            zlevel: 1000,
            data: [
              {
                value: that.pc,
                itemStyle: {
                  color: "#FDC130",
                },
                label: that.label,
                labelLine: that.labelLine,
              },
              {
                value: that.total - that.pc,
                tooltip: { show: false },
                itemStyle: {
                  color: "#EEEEEE",
                },
              },
            ],
          },

          {
            name: "安卓手机",
            type: "pie",
            // startAngle: 0,
            radius: ["42%", "52%"],
            center: ["50%", "50%"],
            legendHoverLink: false,
            // hoverAnimation: false,
            emphasis: {
              scale: false,
            },
            // avoidLabelOverlap: false,
            zlevel: 100,
            labelLine: {
              show: false,
            },

            data: [
              {
                value: that.android,
                itemStyle: {
                  color: "#FF6385",
                },
                label: that.label,
                labelLine: that.labelLine,
              },
              {
                value: that.total - that.android,
                itemStyle: {
                  color: "#EEEEEE",
                },
                tooltip: { show: false },
              },
            ],
          },

          {
            name: "苹果手机",
            type: "pie",
            // startAngle: 0,
            // hoverAnimation: false,
            emphasis: {
              scale: false,
            },
            radius: ["54%", "64%"],
            center: ["50%", "50%"],
            labelLine: {
              show: false,
            },

            data: [
              {
                value: that.iPhone,
                itemStyle: {
                  color: "#6989F8",
                },
                label: that.label,
                labelLine: that.labelLine,
              },
              {
                value: that.total - that.iPhone,
                tooltip: { show: false },
                itemStyle: {
                  color: "#EEEEEE",
                },
              },
            ],
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>

<style scoped lang="scss">
#system-env {
  margin: 0 auto;
  overflow: visible;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/userManagement/groupPortrait/SystemEnv.vue